<template>
  <div class="aptitude_safe">
    <div class="as_banner">
      <div class="as_banner_info">
        <h1>互联网认证服务，帮助平台搭建安全业务体系</h1>
        <h2>
          为互联网平台提供认证体系搭建咨询和实施服务，从准入规则、认证分级、验证流程到结果应用，
        </h2>
        <h2 class="Mt12">
          解决互联网平台上的违规虚假、品牌仿冒、用户欺诈的问题，净化平台服务和交易环境。
        </h2>
        <div class="as_banner_ljsq" @click="showSubmitDialog">
          <p>立即咨询</p>
        </div>
      </div>
    </div>
    <div class="as_section1">
      <h1>行业痛点</h1>
      <div class="as_tongdian">
        <div class="as_tongdian_item">
          <img src="@/assets/images/zizhi/tongdian1@2x.png" alt="" />
          <h2>社会责任要求</h2>
          <h3>网络安全法要求经营者互联网开展经营和服务</h3>
          <h3>活动，应当遵守商业道德，诚实信用，</h3>
          <h3 class="Mt24">并对平台的服务负有监督义务和社会责任。</h3>
        </div>
        <div class="as_tongdian_item">
          <img src="@/assets/images/zizhi/tongdian2@2x.png" alt="" />
          <h2>缺乏认证体系策略运营经验</h2>
          <h3>互联网认证运营需要从用户帐号入驻、认证、使</h3>
          <h3>用多环节进行监督和管控；</h3>
          <h3 class="Mt24">而不同行业的经营准入和要求，国家有严格的</h3>
          <h3>要求。</h3>
        </div>
        <div class="as_tongdian_item">
          <img src="@/assets/images/zizhi/tongdian3@2x.png" alt="" />
          <h2>高额运营成本</h2>
          <h3>认证运营过程中的数据接口验证、平台搭建等服务</h3>
          <h3>均有准入门槛；</h3>
          <h3 class="Mt24">可能面临用户不规律增长带来的人员短缺和冗余，</h3>
          <h3>导致资源浪费；</h3>
          <h3 class="Mt24">密集型作业团队给管理也带来更多的风险和成本。</h3>
        </div>
      </div>
    </div>
    <div class="as_section2">
      <h1>服务内容</h1>
      <div class="as_service">
        <div class="as_service_item">
          <img src="@/assets/images/zizhi/service1@2x.png" alt="" />
          <h2>互联网社交平台认证</h2>
          <h3>为互联网社交平台提供认证体系搭建解决方案，帮</h3>
          <h3>助平台搭建个人认证体系、企业&机构认证体系。</h3>
        </div>
        <div class="as_service_item">
          <img src="@/assets/images/zizhi/service2@2x.png" alt="" />
          <h2>电商平台商户入驻和品牌认证</h2>
          <h3>为电商平台提供商户入驻、品牌验证体系解决方案，</h3>
          <h3>帮助平台验证商户资质、品牌授权等问题，为网民交</h3>
          <h3>易提供信任保障。</h3>
        </div>
      </div>
    </div>
    <div class="as_section3">
      <h1>服务流程</h1>
      <img src="@/assets/images/zizhi/liucheng3_detail@2x.png" alt="" />
      <div class="as_liucheng">
        <h2>平台需求调研</h2>
        <h2>准入&禁入标准设计</h2>
        <h2>系统及团队搭建</h2>
        <h2>审核实施</h2>
        <h2>审核通过&禁入</h2>
      </div>
    </div>
    <div class="as_section4">
      <h1>服务优势</h1>
      <div class="as_advantage">
        <div class="as_advantage_item">
          <img src="@/assets/images/zizhi/youshi1@2x.png" alt="" />
          <h2>1小时迅速响应</h2>
          <h3>1小时内响应</h3>
          <h3>48小时内通过</h3>
        </div>
        <div class="as_advantage_item">
          <img src="@/assets/images/zizhi/youshi2@2x.png" alt="" />
          <h2>99.5%准确率交付</h2>
          <h3>准确率高于99.5%</h3>
          <h3>投诉率低于0.0005%</h3>
        </div>
        <div class="as_advantage_item">
          <img src="@/assets/images/zizhi/youshi3@2x.png" alt="" />
          <h2>0信息安全事故</h2>
          <h3>数据加密传输</h3>
          <h3>作业现场网络隔离</h3>
        </div>
        <div class="as_advantage_item">
          <img src="@/assets/images/zizhi/youshi4@2x.png" alt="" />
          <h2>人审规模600+</h2>
          <h3>团队规模超600人</h3>
          <h3>日审核企业超6W家</h3>
        </div>
      </div>
    </div>
    <div class="as_section5">
      <h1>合作客户</h1>
      <div class="as_hezuo">
        <img src="@/assets/images/zizhi/weixin@2x.png" alt="" />
        <img src="@/assets/images/zizhi/jingdong@2x.png" alt="" />
        <img src="@/assets/images/zizhi/douyin@2x.png" alt="" />
        <img src="@/assets/images/zizhi/kuaishou@2x.png" alt="" />
        <img src="@/assets/images/zizhi/weibo@2x.png" alt="" />
      </div>
      <div class="as_hezuo_btn" @click="showSubmitDialog">
        <p>立即咨询</p>
      </div>
    </div>
    <submitDialog ref="submitDialog"></submitDialog>
  </div>
</template>

<script>
import submitDialog from '@/components/SubmitDialog'
export default {
  metaInfo: {
    title: '互联网认证服务|社交平台认证_商户入驻_品牌认证-知道创宇云安全',
  },
  components: {
    submitDialog,
  },
  methods: {
    showSubmitDialog() {
      this.$refs.submitDialog.dialogVisible = true
    },
  },
  mounted() {
    const mvp = document.getElementById('testViewport')
    mvp.setAttribute('content', 'width=1230')
  },
}
</script>

<style lang="scss">
.aptitude_safe {
  color: #333;
  text-align: center;
  .as_banner {
    background-image: url('../../../assets/images/zizhi/banner_detail@2x.png');
    background-position: center;
    background-size: cover;
    height: 380px;
    min-width: 1230px;
    text-align: left;
    .as_banner_info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 1200px;
      height: 380px;
      margin: 0 auto;
      h1 {
        color: #ecedf4;
        font-size: 32px;
        margin-bottom: 30px;
      }
      h2 {
        color: #979bb6;
        font-size: 16px;
      }
      .as_banner_ljsq {
        margin-top: 43px;
        cursor: pointer;
        width: 160px;
        height: 48px;
        background: url('../../../assets/images/content/ljsq_bg@2x.png')
          no-repeat;
        background-size: 160px 48px;
        &:hover {
          opacity: 0.9;
        }
        p {
          color: #fff;
          text-align: center;
          line-height: 48px;
          font-size: 18px;
        }
      }
    }
  }
  .as_section1 {
    background: #f6f8fb;
    padding-top: 63px;
    padding-bottom: 80px;
    min-width: 1230px;
    h1 {
      font-size: 30px;
      margin-bottom: 63px;
    }
    .as_tongdian {
      display: flex;
      justify-content: center;
      text-align: center;
      .as_tongdian_item {
        width: 384px;
        height: 480px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(229, 229, 229, 1);
        box-sizing: border-box;
        margin-right: 24px;
        flex: none;
        &:last-child {
          margin-right: 0;
          width: 390px;
          h3 {
            margin-left: 22px;
          }
        }
        img {
          width: 120px;
          height: 120px;
          margin-top: 57px;
        }
        h2 {
          font-size: 24px;
          margin-top: 16px;
          margin-bottom: 32px;
        }
        h3 {
          text-align: left;
          color: #888888;
          font-size: 16px;
          line-height: 24px;
          margin-left: 24px;
        }
      }
    }
  }
  .as_section2 {
    padding-top: 80px;
    padding-bottom: 80px;
    min-width: 1230px;
    h1 {
      font-size: 30px;
      margin-bottom: 63px;
    }
    .as_service {
      display: flex;
      justify-content: center;
      .as_service_item {
        width: 440px;
        height: 336px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(229, 229, 229, 1);
        margin-right: 79px;
        box-sizing: border-box;
        &:last-child {
          margin-right: 0;
        }
        img {
          width: 105px;
          height: 120px;
          margin-top: 28px;
        }
        h2 {
          font-size: 24px;
          margin-top: 12px;
          margin-bottom: 24px;
        }
        h3 {
          color: #888888;
          font-size: 16px;
          line-height: 26px;
          text-align: left;
          margin-left: 48px;
        }
        &:last-child {
          h3 {
            margin-left: 44px;
          }
        }
      }
    }
  }
  .as_section3 {
    padding-top: 80px;
    padding-bottom: 78px;
    background: #f6f8fb;
    min-width: 1230px;
    h1 {
      font-size: 30px;
      margin-bottom: 64px;
    }
    img {
      width: 1105px;
      height: 120px;
    }
    .as_liucheng {
      width: 1090px;
      margin: 0 auto;
      margin-top: 32px;
      display: flex;
      justify-content: space-between;
      h2 {
        font-size: 16px;
        &:nth-child(2) {
          margin-left: 128px;
        }
        &:nth-child(3) {
          margin-left: 120px;
        }
        &:nth-child(4) {
          margin-left: 160px;
        }
        &:nth-child(5) {
          margin-left: 160px;
        }
      }
    }
  }
  .as_section4 {
    padding-top: 80px;
    padding-bottom: 80px;
    min-width: 1230px;
    h1 {
      font-size: 30px;
      margin-bottom: 63px;
    }
    .as_advantage {
      width: 1194px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      .as_advantage_item {
        width: 280px;
        height: 280px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(229, 229, 229, 1);
        img {
          width: 80px;
          height: 80px;
          margin-top: 40px;
        }
        h2 {
          font-size: 24px;
          margin-top: 16px;
          margin-bottom: 18px;
        }
        h3 {
          color: #888888;
          font-size: 16px;
          line-height: 24px;
        }
      }
    }
  }
  .as_section5 {
    background: #f6f8fb;
    padding-top: 80px;
    padding-bottom: 80px;
    min-width: 1230px;
    h1 {
      font-size: 30px;
      margin-bottom: 64px;
    }
    .as_hezuo {
      display: flex;
      justify-content: center;
      margin-bottom: 80px;
      img {
        width: 200px;
        height: 160px;
        margin-right: 31px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
    .as_hezuo_btn {
      display: flex;
      justify-content: center;

      p {
        width: 160px;
        height: 48px;
        background: rgba(10, 158, 250, 1);
        border-radius: 2px;
        color: #fff;
        line-height: 48px;
        font-size: 18px;
        cursor: pointer;
        &:hover {
          opacity: 0.9;
        }
      }
    }
  }
}
</style>
